import { render } from "./PublicFooter.vue?vue&type=template&id=72a1d9ae&scoped=true&ts=true"
import script from "./PublicFooter.vue?vue&type=script&lang=ts"
export * from "./PublicFooter.vue?vue&type=script&lang=ts"

import "./PublicFooter.vue?vue&type=style&index=0&id=72a1d9ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a1d9ae"]])

export default __exports__